var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"element-fullscreen"},[_vm._t("default",null,{"fullscreen":_vm.fullscreen,"toggleFullscreen":_vm.toggleFullscreen})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }